import { file_to_keys } from "./file_to_keys_mapping";

export const file_validator = (selected_plant, key_name, headers) => {
  let isValid = true;
  const missing_keys = [];
  const map = {};
  headers.forEach((key) => {
    map[key.toLowerCase().split("_").join(" ").trim()] = 1;
  });
  // console.log({ key_name });
  // console.log({ valid_keys: file_to_keys?.[selected_plant]?.[key_name].required });
  // console.log({ headers });
  file_to_keys?.[selected_plant]?.[key_name].required.forEach((value) => {
    if (!map[value.split("_").join(" ").trim().toLowerCase()]) {
      isValid = false;
      missing_keys.push(value);
    }
  });
  if (!isValid) {
    return {
      isValid,
      missing_keys
    };
  }
  return {
    isValid,
    missing_keys
  };
};